module.exports = __webpack_public_path__ + "static/GT-Super-Display-Light-8d5243ef5f479acc248daaac4c03b106.woff";